"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var Indeed = function Indeed(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "Indeed"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.21924 14.3731V8.53432C5.39068 8.54953 5.55383 8.55644 5.7239 8.55644C6.50562 8.56013 7.27413 8.35488 7.94992 7.96191V14.3731C7.94992 14.9262 7.81995 15.3258 7.56831 15.5954C7.44132 15.7293 7.2872 15.8347 7.11624 15.9043C6.94528 15.9739 6.76143 16.0062 6.57697 15.9991C6.39397 16.0045 6.21196 15.9703 6.04345 15.8987C5.87495 15.8271 5.72395 15.7198 5.60084 15.5843C5.35059 15.3147 5.21924 14.9096 5.21924 14.3704"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.23588 0.376791C6.92544 -0.217736 8.85143 -0.185935 10.2977 1.03492C10.5742 1.28103 10.8742 1.58797 10.9973 1.95574C11.1438 2.41616 10.4857 1.90735 10.3958 1.84514C9.93836 1.54046 9.44403 1.29515 8.92471 1.11511C6.08204 0.257885 3.39422 1.80642 1.71849 4.20942C1.04568 5.26584 0.530966 6.41498 0.190688 7.62035C0.159632 7.7687 0.110408 7.91265 0.0441307 8.04896C-0.0291483 8.18722 0.010947 7.68533 0.010947 7.66874C0.0718038 7.16492 0.169777 6.66628 0.304064 6.17689C1.07557 3.5582 2.78172 1.37643 5.23588 0.376791Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.44118 6.8751C6.95665 7.11915 6.39578 7.16362 5.87885 6.99897C5.36192 6.83433 4.93008 6.47368 4.67594 5.99437C4.55302 5.75832 4.47886 5.49994 4.45785 5.23464C4.43684 4.96933 4.46943 4.7025 4.55367 4.45005C4.6379 4.19759 4.77207 3.96466 4.94819 3.76513C5.1243 3.56559 5.33875 3.40353 5.57879 3.28858C6.06332 3.04453 6.62419 3.00006 7.14112 3.16471C7.65805 3.32935 8.08989 3.69 8.34403 4.16931C8.46714 4.40533 8.54147 4.66371 8.56257 4.92907C8.58368 5.19443 8.55113 5.46132 8.46688 5.71383C8.38262 5.96633 8.24838 6.19929 8.07216 6.3988C7.89594 6.59832 7.68135 6.7603 7.44118 6.8751Z"
  }));
};

var _default = Indeed;
exports["default"] = _default;